module.exports = __webpack_public_path__ + "a423a2ce68a00831c2ee3e6df62a3d53.png";